import FormDialog from '@/components/ui/form-dialog';
import { FunctionComponent, ReactElement } from 'react';
import { Device } from '@/core/entities';
import useToastMessage from '@/shared/context/toast-message-context';
import { deleteDevice } from '@/api/devices';
import { useMutation } from '@tanstack/react-query';
import { pushToDataLayer, ContentGroup } from '@/shared/utils/analytics';

interface DeleteDeviceFormProps {
	open: boolean;
	onClose: () => void;
	device?: Device;
	onSubmitted?: () => void;
	customerName?: string;
}

const DeleteDeviceForm: FunctionComponent<DeleteDeviceFormProps> = ({
	open,
	onClose,
	device,
	onSubmitted,
	customerName,
}): ReactElement => {
	const { dispatch } = useToastMessage();

	const trackRemoveDevice = () => {
		pushToDataLayer({
			event: 'device_removed',
			content_group: ContentGroup.Customers,
			customer_name: customerName,
		});
	};

	const { mutate } = useMutation({
		mutationFn: (id: string) => deleteDevice(id),
		onSuccess: () => {
			dispatch({
				type: 'success',
				content: 'Device successfully removed!',
			});
			onClose();
			onSubmitted?.();
			trackRemoveDevice();
		},
	});

	return (
		<FormDialog
			title="Remove device"
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="xs"
			actions={{
				cancel: { label: 'Cancel' },
				confirm: { label: 'Remove device' },
			}}
			onSubmit={() => device && mutate(device.id)}
		>
			{device &&
				`Are you sure you wish to remove device ${device.name}? This action cannot be undone.`}
		</FormDialog>
	);
};

export default DeleteDeviceForm;
